export function switchChatStatus(status = 'none') {
	return {
				type: 'CHAT_SET_STATUS',
				payload:status
			}
}

export function addMessage(uid,message) {
	return {
		type:'CHAT_ADD_MESSAGE',
		payload:{uid,message}
	}
}

export function setVisitorKey(uid,key,value) {
	return {
		type:'CHAT_SET_VISITOR_KEY',
		payload:{uid,key,value}
	}
}

export function chatSetGlobalKey(key,value) {
	return {
		type:'CHAT_SET_GLOBAL_KEY',
		payload:{key,value}
	}
}

export function addCarts(carts) {
    return {
        type: 'CHAT_ADD_CARTS',
        payload:carts
    }
}

export function addPages(pages) {
    return {
        type: 'CHAT_ADD_PAGES',
        payload:pages
    }
}

export function addVisitors(visitors) {
	return {
				type: 'CHAT_ADD_VISITORS',
				payload:visitors
			}
}
export function setInit(status) {
	return {
				type: 'CHAT_SET_INIT',
				payload:status
			}
}

export function setAssignee(user_id,uid) {
	return {
				type: 'CHAT_SET_ASSIGNEE',
				payload:{uid,user_id}
			}
}
export function removeVisitor(uid) {
	return {
				type: 'CHAT_REMOVE_VISITOR',
				payload:uid
			}
}
export function removeFilterOption(index) {
	return {
				type: 'CHAT_REMOVE_FILTER_OPTION',
				payload:index
			}
}
export function setFilterOption(option) {
	return {
				type: 'CHAT_SET_FILTER_OPTION',
				payload:option
			}
}
export function resetFilterOption() {
	return {
				type: 'CHAT_RESET_FILTER',
				payload:true
			}
}
export function addVisitor(visitor) {
	return {
				type: 'CHAT_ADD_VISITOR',
				payload:visitor
			}
}
export function updateVisitor(visitor) {
	return {
				type: 'CHAT_UPDATE_VISITOR',
				payload:visitor
			}
}
export function setOpenChat(uid,tab) {
	return {
				type: 'CHAT_SET_OPEN_CHAT',
				payload:{uid,tab}
			}
}

export function addVisitorData(key,uid,data) {
	return {
				type: 'CHAT_ADD_VISITOR_DATA',
				payload:{key,uid,data}
			}
}


export function setCurrentTab(tab) {
	return {
				type: 'CHAT_SET_TAB',
				payload:tab
			}
}


// WEBPACK FOOTER //
// ./actions/Chat.js